export enum TierTargetEnum {
    BEST_QUALIFIED = 'BEST_QUALIFIED',
    BEST_PRICE = 'BEST_PRICE',
}
